(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qr-tea-collection"] && !Shopify.designMode) return;
  try {
    
function bindQrTea(){
document.querySelectorAll('[data-qr-tea]').forEach(root=>{
if(root.dataset.bound)return;
root.dataset.bound='true';
root.querySelectorAll('.qr-form').forEach(form=>form.addEventListener('submit',async event=>{
const button=form.querySelector('button');
if(button.disabled)return;
event.preventDefault();
const label=button.textContent;
button.disabled=true;button.textContent=root.dataset.loading;
const status=root.querySelector('[data-cart-status]');status.textContent='';
try{
const body=new FormData(form);body.delete('return_to');
const response=await fetch(form.action+'.js',{method:'POST',body,headers:{Accept:'application/json'}});
const result=await response.json();
if(!response.ok)throw new Error(result.description||root.dataset.error);
status.textContent=root.dataset.added;
const cartPath=form.querySelector('[name="return_to"]').value;
try{const cartResponse=await fetch(cartPath+'.js',{headers:{Accept:'application/json'}});if(cartResponse.ok){const cart=await cartResponse.json();root.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+cart.item_count+')');}}catch{}
}catch(error){status.textContent=error.message||root.dataset.error;}
finally{button.disabled=false;button.textContent=label;}
}));
});
}
bindQrTea();
document.addEventListener('shopify:section:load',bindQrTea);

  } catch(e) { console.error(e); }
})();
})();
